import { FC, ReactNode } from 'react'
import { Text, TextColor } from '@agro-club/agroclub-shared'

export const Label: FC<{ children: ReactNode; color?: TextColor }> = ({ children, color }) => {
  return (
    <Text as="span" typography="bodyMedium" color={color}>
      {children}
    </Text>
  )
}

export const Value: FC<{ children: ReactNode; color?: TextColor }> = ({ children, color }) => {
  return (
    <Text as="span" typography="accentMedium" color={color}>
      {children}
    </Text>
  )
}

export const FormLabel: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Text typography="bodyMedium" color="secondary">
      {children}
    </Text>
  )
}

export const SmallRadioText: FC<{ children: ReactNode }> = ({ children }) => {
  return <Text typography="bodyMedium">{children}</Text>
}
